/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/anchor-is-valid */

import React, { PureComponent } from 'react';
import {
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  FormControl,
  ListSubheader,
} from '@mui/material';
import styled from 'styled-components';
import { v4 } from 'uuid';
import { ILookupOption } from '../../state/lookups';

export interface IState {
  optionsLabelValueMap: Map<string, string>;
  optionsValueArray: string[];
}

export interface IProps {
  onChange: (result: string[]) => void;
  onChangeGroup: (option: ILookupOption) => void;
  isLoading: boolean;
  options: Array<ILookupOption>;
  selectedOptions: string[];
  noneSelectedText?: string;
  dataAuto?: string;
}

export const Input = styled(OutlinedInput)`
  flex-grow: 1;
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  & > .MuiFormLabel-root {
    top: -4px;
    left: 9px;
  }
  & > .MuiFormLabel-root.Mui-focused, & > .MuiFormLabel-root.MuiFormLabel-filled {
    padding-top: 4px;
    padding-left: 4px;
    top: 0;
    left: 0;
  }
`;

const sortValuesFromOptions = (values: string[], options: string[]): string[] => {
  values.sort((a, b) => options.indexOf(a) - options.indexOf(b));
  return values;
};

class CheckBoxSelect extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const optionsLabelValueMap: Map<string, string> = new Map();
    const optionsValueArray: string[] = [];
    props.options.forEach((option) => {
      if (option.children.length > 0) {
        option.children.forEach((child) => {
          optionsValueArray.push(child.value);
          optionsLabelValueMap.set(child.value, child.label);
        });
      } else {
        optionsValueArray.push(option.value);
        optionsLabelValueMap.set(option.value, option.label);
      }
    });

    this.state = {
      optionsLabelValueMap,
      optionsValueArray,
    };
  }

  render() {
    const {
      optionsLabelValueMap,
      optionsValueArray,
    } = this.state;

    const {
      onChange,
      onChangeGroup,
      isLoading,
      options,
      selectedOptions,
      noneSelectedText,
      dataAuto,
    } = this.props;

    const dataAutoString = dataAuto ? 'checkBoxSelect' : dataAuto;

    return (
      <StyledFormControl>
        <Select
          multiple
          value={selectedOptions}
          displayEmpty
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em style={{ color: '#c2c2c2' }}>{noneSelectedText}</em>;
            }

            return selected.map((value) => optionsLabelValueMap.get(value)).join(', ');
          }}
          input={<Input />}
          onChange={(event) => { onChange(sortValuesFromOptions(event.target.value as string[], optionsValueArray)); }}
          disabled={isLoading}
          data-auto={dataAutoString}
        >
          {options.map(({ value, label, children }) => {
            if (children.length > 0) {
              const items = children.map((child) => (
                <MenuItem
                  style={{ paddingLeft: '24px' }}
                  value={child.value}
                  key={v4()}
                >
                  <Checkbox checked={selectedOptions.includes(child.value)} />
                  <ListItemText primary={child.label} />
                </MenuItem>
              ));
              // note: need to use anchor tag for click event
              items.unshift((
                <ListSubheader key={v4()}>
                  <a
                    onClick={(e) => {
                      onChangeGroup({ value, label, children } as ILookupOption);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {label}
                  </a>
                </ListSubheader>
              ));
              return items;
            }
            return (
              <MenuItem value={value} key={v4()}>
                <Checkbox checked={selectedOptions.includes(value)} />
                <ListItemText primary={label} />
              </MenuItem>
            );
          })}
        </Select>
      </StyledFormControl>
    );
  }
}

export default CheckBoxSelect;
